<template>
    <div class="modal" v-if="value">
        <div class="modal-mask" @click.self="handleClose">
            <div class="container">
                <div class="header">
                    <img src="/static/images2/clear.png" alt="" @click="handleClose">
                </div>
                <div class="title">扫描二维码开始下载</div>
                <div class="tip">(无需区分安卓或ios)</div>
                <img class="app" src="/static/images2/app.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'dowModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel');
    }
  }
}
</script>
<style scoped lang="less">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
}

.modal-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
    background: linear-gradient( 180deg, #CBEFFE 0%, #FFFFFF 26%);
    border-radius: 14px;
    padding: 24px 24px 66px;
    text-align: center;
    .header {
        display: flex;
        justify-content: flex-end;

        img {
            width: 32px;
            height: 32px;
        }
    }
    .title {
        font-weight: 700;
        font-size: 20px;
        color: #1D2129;
        line-height: 28px;
        margin: 0 155px 8px;
    }
    .tip {
        font-weight: 400;
        font-size: 14px;
        color: #4E5969;
        line-height: 22px;
        margin: 0 auto 24px;
    }
    .app {
        width: 180px;
        height: 180px;
        object-fit: cover;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/dowModal.vue